// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCreditCard = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16.5 13a1.5 1.5 0 100 3 1.5 1.5 0 000-3" />,
    <path
      fillRule="evenodd"
      d="M2 7a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3zm3-1a1 1 0 00-1 1v1h16V7a1 1 0 00-1-1zM4 17v-6h16v6a1 1 0 01-1 1H5a1 1 0 01-1-1"
    />
  );
export default SvgIconCreditCard;
